import React, { ChangeEvent } from 'react';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';

import JabraFileUpload from 'components/Shared/JabraFileUpload';
import { RichLabelProps } from 'components/Shared/JabraLabel';
import { FileUploadViewModel } from 'src/types/fileUpload';

const FileUpload: React.FunctionComponent<ValueFieldProps<FileUploadViewModel>> = (props) => {
  const { errors, field, ...restProps } = props;
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const Label = props.labelComponent as React.FC<RichLabelProps>;

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files ? [...event.target.files] : [];
    props.onChange(field.valueField.name, files, restProps.isValid, []);
  };

  return (
    <>
      {!!Label && <Label richTitle={field.model?.title} {...props} />}
      <JabraFileUpload
        id={field.valueField.id}
        name={field.valueField.name}
        jssMetadata={props}
        required={field.model.required}
        onChange={onChange}
      />
      {!!FieldValidationErrors && (
        <FieldValidationErrors
          field={field}
          errors={errors.map((error) => field.model.validationErrorMessage || error)}
          {...restProps}
        />
      )}
    </>
  );
};

export default FileUpload;
